import { FeatureTypeApiModel } from '../../../types/models/feature-type.model';
import { CreateFeatureTypeApiRequest } from '../../../types/requests/feature-types/create-feature-type.request';
import { DeleteFeatureTypeApiRequest } from '../../../types/requests/feature-types/delete-feature-type.request';
import { GetFeatureTypeApiRequest } from '../../../types/requests/feature-types/get-feature-type.request';
import { SearchFeatureTypesApiRequest } from '../../../types/requests/feature-types/search-feature-types.request';
import { UpdateFeatureTypeApiRequest } from '../../../types/requests/feature-types/update-feature-type.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createFeatureType = (params: CreateFeatureTypeApiRequest) =>
  client.post<FeatureTypeApiModel>('/feature-types', params);

export const updateFeatureType = ({ featureTypeId, ...params }: UpdateFeatureTypeApiRequest) =>
  client.patch<FeatureTypeApiModel>(`/feature-types/${featureTypeId}`, params);

export const getFeatureType = <T extends FeatureTypeApiModel>({ featureTypeId, ...params }: GetFeatureTypeApiRequest) =>
  client.get<T>(`/feature-types/${featureTypeId}`, { params });

export const searchFeatureTypes = (params: SearchFeatureTypesApiRequest) =>
  client.get<CursorPaginatedApiResponse<FeatureTypeApiModel>>(`/feature-types`, { params });

export const deleteFeatureType = ({ featureTypeId }: DeleteFeatureTypeApiRequest) =>
  client.delete<void>(`/feature-types/${featureTypeId}`);
